import { __assign } from 'tslib';
import { isDigit } from './utils.js';
import 'date-fns/clamp';
import 'date-fns/getDaysInMonth';
import '../consts.js';

function createPreventCaretJumpPostprocessor() {
    return function (state, prevState) {
        var _a = prevState.selection, prevFrom = _a[0], prevTo = _a[1];
        var selection = state.selection, value = state.value;
        var from = selection[0], to = selection[1];
        var prevPosIsEqual = prevFrom === prevTo;
        var posIsEqual = from === to;
        if (prevPosIsEqual && posIsEqual && from - prevFrom > 1 && !isDigit(value[from - 1])) {
            var caretPos = from - 1;
            while (caretPos > 0 && !isDigit(value[caretPos - 1])) {
                caretPos -= 1;
            }
            return __assign(__assign({}, state), { selection: [caretPos, caretPos] });
        }
        return state;
    };
}

export { createPreventCaretJumpPostprocessor };
